
export default function Philosophy() {
  return (
    <section id="philosophy" className="py-16 sm:py-20 lg:py-32 bg-[#F8F6F3]">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <p className="text-xs tracking-widest text-gray-500 mb-4 sm:mb-6 uppercase">우리의 접근 방식</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-6 sm:mb-8">
              건축은<br />공간을 만드는<br />사려 깊은 작업입니다
            </h2>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
              우리는 위대한 건축이 장소, 목적, 그리고 사람에 대한 깊은 이해에서 비롯된다고 믿습니다. 모든 프로젝트는 경청으로 시작됩니다—당신의 비전, 부지, 그리고 커뮤니티에 귀 기울입니다. 우리의 디자인 철학은 혁신과 지속가능성의 경계를 넓히면서 인간의 필요에 부응하는 시대를 초월한 공간을 창조하는 데 중점을 둡니다.
            </p>
          </div>

          <div className="space-y-4 sm:space-y-6">
            <div className="bg-[#2C4A3E] rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 xl:p-12 shadow-xl">
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center space-x-3 sm:space-x-4 min-w-0">
                  <div className="w-11 h-11 sm:w-14 sm:h-14 rounded-full overflow-hidden bg-gray-300 flex-shrink-0">
                    <img
                      src="https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/da0e6e60fb7c76c3cb7423aa1f533d9a.png"
                      alt="고객"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="min-w-0">
                    <p className="text-white font-semibold text-base sm:text-lg truncate">한아름</p>
                    <p className="text-white/70 text-xs sm:text-sm truncate">Project Lab</p>
                  </div>
                </div>
                <a
                  href="#portfolio"
                  className="hidden sm:inline-block px-4 sm:px-6 py-2.5 sm:py-3 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors text-xs sm:text-sm whitespace-nowrap cursor-pointer flex-shrink-0"
                >
                  프로젝트 보기 →
                </a>
                <a
                  href="#portfolio"
                  className="sm:hidden w-9 h-9 flex items-center justify-center bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors cursor-pointer flex-shrink-0"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </a>
              </div>
            </div>

            <div className="bg-[#2C4A3E] rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-10 xl:p-12 shadow-xl">
              <div className="flex items-center justify-between gap-4">
                <div className="flex items-center space-x-3 sm:space-x-4 min-w-0">
                  <div className="w-11 h-11 sm:w-14 sm:h-14 rounded-full overflow-hidden bg-gray-300 flex-shrink-0">
                    <img
                      src="https://static.readdy.ai/image/2ff082740ef8d0a17f9e9dada91b9777/8df257065eac28710ea4d872e20b55e9.jpeg"
                      alt="고객"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="min-w-0">
                    <p className="text-white font-semibold text-base sm:text-lg truncate">한덕운</p>
                    <p className="text-white/70 text-xs sm:text-sm truncate">Project Shop</p>
                  </div>
                </div>
                <a
                  href="#portfolio"
                  className="hidden sm:inline-block px-4 sm:px-6 py-2.5 sm:py-3 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors text-xs sm:text-sm whitespace-nowrap cursor-pointer flex-shrink-0"
                >
                  프로젝트 보기 →
                </a>
                <a
                  href="#portfolio"
                  className="sm:hidden w-9 h-9 flex items-center justify-center bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors cursor-pointer flex-shrink-0"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
